import React from 'react';
import { BookOpen, Music, FileText, Award, Calendar, Layers, Printer, Check } from 'lucide-react';
export function ContentsSection() {
  return <section className="w-full bg-gray-50 py-12 md:py-20 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        {/* Title */}
        <div className="text-center mb-10 md:mb-12" data-id="element-3">
          <p className="font-nunito font-bold text-orange-500 text-base md:text-lg uppercase tracking-widest mb-2 flex items-center justify-center gap-2" data-id="element-4">
            <BookOpen className="w-5 h-5" data-id="element-5" /> Contenido Completo
          </p>
          <h2 className="font-nunito font-black text-gray-900 text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-6">
            ¿QUÉ RECIBES <span className="text-purple-700" data-id="element-7">EXACTO?</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-8">
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-9" />
            <Music className="w-6 h-6 text-orange-400" data-id="element-10" />
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-11" />
          </div>
        </div>

        {/* Main PDF badge */}
        <div className="bg-purple-700 rounded-2xl p-6 text-center mb-8 flex flex-col items-center gap-2" data-id="element-12">
          <BookOpen className="w-10 h-10 text-purple-200" data-id="element-13" />
          <p className="font-nunito font-black text-white text-xl md:text-3xl" data-id="element-14">
            eBook PDF Único (60 páginas)
          </p>
          <p className="text-purple-200 font-semibold" data-id="element-15">
            TODO EN 1 DESCARGA — CERO ENLACES EXTERNOS
          </p>
        </div>

        {/* Table - with horizontal scroll on mobile */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 mb-8 md:mb-10" data-id="element-16">
          <div className="overflow-x-auto" data-id="element-17">
            <table className="w-full min-w-[480px]" role="table" data-id="element-18">
              <thead data-id="element-19">
                <tr className="bg-gradient-to-r from-orange-500 to-purple-600" data-id="element-20">
                  <th className="text-left text-white font-nunito font-black text-base px-6 py-4" data-id="element-21">
                    SECCIÓN
                  </th>
                  <th className="text-left text-white font-nunito font-black text-base px-6 py-4" data-id="element-22">
                    CONTENIDO
                  </th>
                  <th className="text-left text-white font-nunito font-black text-base px-6 py-4" data-id="element-23">
                    PÁGINAS
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-24">
                <tr className="border-b border-gray-100 hover:bg-orange-50 transition-colors" data-id="element-25">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-26">
                    <span className="flex items-center gap-2" data-id="element-27">
                      <Layers className="w-4 h-4 text-orange-400" data-id="element-28" /> Portada +
                      Índice
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-29">
                    Introducción e instrucciones
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-30">1-5</td>
                </tr>
                <tr className="border-b border-gray-100 bg-orange-50/50 hover:bg-orange-50 transition-colors" data-id="element-31">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-32">
                    <span className="flex items-center gap-2" data-id="element-33">
                      <Music className="w-4 h-4 text-orange-400" data-id="element-34" /> 40 Planes
                      Semanales
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-35">
                    1 página/semana completa
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-36">6-45</td>
                </tr>
                <tr className="border-b border-gray-100 hover:bg-orange-50 transition-colors" data-id="element-37">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-38">
                    <span className="flex items-center gap-2" data-id="element-39">
                      <FileText className="w-4 h-4 text-orange-400" data-id="element-40" /> 10
                      Plantillas
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-41">
                    Imprimibles listas
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-42">46-55</td>
                </tr>
                <tr className="border-b border-gray-100 bg-orange-50/50 hover:bg-orange-50 transition-colors" data-id="element-43">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-44">
                    <span className="flex items-center gap-2" data-id="element-45">
                      <Award className="w-4 h-4 text-orange-400" data-id="element-46" /> Certificados
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-47">
                    2 diseños para alumnos
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-48">56-57</td>
                </tr>
                <tr className="border-b border-gray-100 hover:bg-orange-50 transition-colors" data-id="element-49">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-50">
                    <span className="flex items-center gap-2" data-id="element-51">
                      <Calendar className="w-4 h-4 text-orange-400" data-id="element-52" />{' '}
                      Calendario Anual
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-53">Vista 40 semanas</td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-54">58</td>
                </tr>
                <tr className="border-b border-gray-100 bg-orange-50/50 hover:bg-orange-50 transition-colors" data-id="element-55">
                  <td className="px-6 py-4 font-nunito font-bold text-gray-900" data-id="element-56">
                    <span className="flex items-center gap-2" data-id="element-57">
                      <Layers className="w-4 h-4 text-orange-400" data-id="element-58" /> 50 Recursos
                      Rápidos
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700" data-id="element-59">
                    Adivinanzas, danzas, juegos
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-700" data-id="element-60">59-60</td>
                </tr>
                <tr className="bg-purple-700" data-id="element-61">
                  <td className="px-6 py-4 font-nunito font-black text-white" data-id="element-62">
                    TOTAL
                  </td>
                  <td className="px-6 py-4 font-bold text-purple-200" data-id="element-63">
                    60 páginas autocontenidas
                  </td>
                  <td className="px-6 py-4 font-bold text-yellow-300" data-id="element-64">
                    60 págs.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* What you can print */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-green-200" data-id="element-65">
          <h3 className="font-nunito font-black text-gray-900 text-lg md:text-xl mb-4 md:mb-5 text-center flex items-center justify-center gap-2" data-id="element-66">
            <Printer className="w-5 h-5 text-green-600" data-id="element-67" /> Imprime cualquier
            página:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-68">
            <div className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-69">
              <Check className="w-4 h-4 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-70" />
              Plan semanal entero
            </div>
            <div className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-71">
              <Check className="w-4 h-4 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-72" />
              Solo la rúbrica evaluación
            </div>
            <div className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-73">
              <Check className="w-4 h-4 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-74" />
              Certificado para alumno
            </div>
            <div className="flex items-center gap-2 text-gray-700 font-semibold" data-id="element-75">
              <Check className="w-4 h-4 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-76" />
              Adivinanza para clase
            </div>
          </div>
        </div>
      </div>
    </section>;
}